var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilSimpleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5766 6.61321L17.3869 2.42446C17.0353 2.07295 16.5584 1.87549 16.0613 1.87549C15.5641 1.87549 15.0872 2.07295 14.7356 2.42446L3.17438 13.9848C2.99968 14.1584 2.86116 14.365 2.76686 14.5925C2.67255 14.8201 2.62434 15.0641 2.62501 15.3104V19.5001C2.62501 19.9974 2.82255 20.4743 3.17418 20.8259C3.52581 21.1775 4.00273 21.3751 4.50001 21.3751H20.25C20.5484 21.3751 20.8345 21.2566 21.0455 21.0456C21.2565 20.8346 21.375 20.5485 21.375 20.2501C21.375 19.9517 21.2565 19.6656 21.0455 19.4546C20.8345 19.2436 20.5484 19.1251 20.25 19.1251H11.7188L21.5766 9.2654C21.7508 9.09128 21.8889 8.88455 21.9832 8.65701C22.0775 8.42948 22.126 8.1856 22.126 7.93931C22.126 7.69301 22.0775 7.44913 21.9832 7.2216C21.8889 6.99406 21.7508 6.78733 21.5766 6.61321ZM8.53126 19.1251H4.87501V15.4688L12.75 7.59384L16.4063 11.2501L8.53126 19.1251ZM18 9.65634L14.3438 6.00009L16.0631 4.28071L19.7194 7.93696L18 9.65634Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimpleLine);
export default __webpack_public_path__ + "static/media/PencilSimpleLine.942c35bdc963f1e9a904ed1084fd78d8.svg";
export { ForwardRef as ReactComponent };